var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { first, iif, isNotNullOrEmpty, isNullOrEmpty, removeKeys } from '@pcty/utils';
import React from 'react';
import { getChildByType } from 'react-nanny';
import InvalidPrimaryKey from './private/InvalidPrimaryKey';
import { SELECTION_TYPES } from './constants';
import Core from './TableCore';
import Tbody from './Tbody';
import Tr from './Tr';
var _defaultProps = {
    disabled: false,
    editId: undefined,
    errorIds: [],
    equalColumnWidths: true,
    expandedIds: [],
    fixedHeader: false,
    fixedLeftColumns: 0,
    fixedRightColumns: 0,
    loading: false,
    lowerPager: true,
    pager: true,
    onChangeSelection: function () { return undefined; },
    renderToolbar: function () { return undefined; },
    selection: {
        type: SELECTION_TYPES.individual,
        items: [],
        selectedCount: 0,
    },
    showOutliers: false,
    upperPager: true,
    warningIds: [],
    __TYPE: 'TablePage',
};
/** DISPLAY NAME: &lt;Table.Page&gt; */
var TablePage = /** @class */ (function (_super) {
    __extends(TablePage, _super);
    function TablePage(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyDownHandler = function (e) {
            if (e.keyCode === 16 || e.key === 'Shift') {
                _this.shiftDown = true;
            }
        };
        _this.onKeyUpHandler = function (e) {
            if (e.keyCode === 16 || e.key === 'Shift') {
                _this.shiftDown = false;
                _this.lastSelection = {
                    id: null,
                    insert: true,
                };
            }
        };
        _this.createRows = _this.createRows.bind(_this);
        _this.createExpandableRows = _this.createExpandableRows.bind(_this);
        _this.checkHandler = _this.checkHandler.bind(_this);
        _this.checkHeaderHandler = _this.checkHeaderHandler.bind(_this);
        _this.onChangePage = _this.onChangePage.bind(_this);
        _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
        _this.onKeyUpHandler = _this.onKeyUpHandler.bind(_this);
        _this.processHead = _this.processHead.bind(_this);
        _this.sortHandler = _this.sortHandler.bind(_this);
        _this.toggleExpansion = _this.toggleExpansion.bind(_this);
        _this.shiftDown = false;
        _this.lastSelection = {
            id: null,
            insert: true,
        };
        return _this;
    }
    TablePage.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onKeyDownHandler);
        document.addEventListener('keyup', this.onKeyUpHandler);
    };
    TablePage.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onKeyDownHandler);
        document.removeEventListener('keyup', this.onKeyUpHandler);
    };
    TablePage.prototype.onChangePage = function (page) {
        var pageConfig = __assign(__assign({}, this.props.pageConfig), { page: page });
        this.props.onChange(pageConfig);
    };
    TablePage.prototype.checkHandler = function (item) {
        var _this = this;
        var _a;
        var selection = this.props.selection;
        var _b = this.props, data = _b.data, itemCount = _b.itemCount, onChangeSelection = _b.onChangeSelection, primaryKey = _b.primaryKey;
        var items = (_a = selection === null || selection === void 0 ? void 0 : selection.items) !== null && _a !== void 0 ? _a : [];
        var _itemIsSelected = itemIsSelected(this.props.primaryKey);
        var excludeItem = function (item, list) {
            var selection = _this.props.selection;
            var _itemInList = itemInList(primaryKey);
            if ((selection === null || selection === void 0 ? void 0 : selection.type) !== SELECTION_TYPES.allExcept ||
                (selection.type === SELECTION_TYPES.allExcept && _itemInList(item, list)))
                return list;
            _this.lastSelection = {
                id: item[primaryKey],
                insert: false,
            };
            return __spreadArray(__spreadArray([], list, true), [item], false);
        };
        var includeItem = function (item, list) {
            var selection = _this.props.selection;
            var _itemInList = itemInList(primaryKey);
            if ((selection === null || selection === void 0 ? void 0 : selection.type) !== SELECTION_TYPES.allExcept || !_itemInList(item, list))
                return list;
            _this.lastSelection = {
                id: item[primaryKey],
                insert: true,
            };
            return list.filter(function (x) { return x[primaryKey] !== item[primaryKey]; });
        };
        var insertToSelected = function (item, selected, removeIfSelected) {
            var selection = _this.props.selection;
            var _itemInList = itemInList(primaryKey);
            if (isNotNullOrEmpty(selected) && selected.findIndex(function (x) { return x[primaryKey] === item[primaryKey]; }) >= 0) {
                if ((selection === null || selection === void 0 ? void 0 : selection.type) !== SELECTION_TYPES.allExcept ||
                    (selection.type === SELECTION_TYPES.allExcept && !removeIfSelected)) {
                    selected = selected.filter(function (x) { return x[primaryKey] !== item[primaryKey]; });
                    _this.lastSelection = {
                        id: item[primaryKey],
                        insert: (selection === null || selection === void 0 ? void 0 : selection.type) === SELECTION_TYPES.allExcept,
                    };
                }
                else if (selection.type === SELECTION_TYPES.allExcept && removeIfSelected && !_itemInList(item, selected)) {
                    selected = includeItem(item, selected);
                    _this.lastSelection = {
                        id: item[primaryKey],
                        insert: false,
                    };
                }
            }
            else if ((selection === null || selection === void 0 ? void 0 : selection.type) !== SELECTION_TYPES.allExcept ||
                (selection.type === SELECTION_TYPES.allExcept && removeIfSelected)) {
                selected = __spreadArray(__spreadArray([], selected, true), [item], false);
                _this.lastSelection = {
                    id: item[primaryKey],
                    insert: (selection === null || selection === void 0 ? void 0 : selection.type) !== SELECTION_TYPES.allExcept,
                };
            }
            return selected;
        };
        var removeFromSelected = function (item, selected) {
            _this.lastSelection = {
                id: item[primaryKey],
                insert: false,
            };
            return selected.filter(function (x) { return x[primaryKey] !== item[primaryKey]; });
        };
        var getSelectionTypeFromAllExcept = function (selection) {
            if (selection.items.length === itemCount) {
                return __assign(__assign({}, selection), { type: SELECTION_TYPES.all, selectedCount: itemCount });
            }
            return __assign(__assign({}, selection), { type: SELECTION_TYPES.allExcept, selectedCount: itemCount - selection.items.length });
        };
        var getSelection = function (item, lastSelectionInsert, selection, shiftClick, remove) {
            if (shiftClick === void 0) { shiftClick = false; }
            if (remove === void 0) { remove = true; }
            var _itemInList = itemInList(primaryKey);
            if (!selection)
                return undefined;
            switch (selection.type) {
                case SELECTION_TYPES.all:
                    // They were all selected, now they're all selected except the item
                    _this.lastSelection = {
                        id: item[primaryKey],
                        insert: false,
                    };
                    return {
                        type: SELECTION_TYPES.allExcept,
                        items: [item],
                        selectedCount: itemCount - 1,
                    };
                case SELECTION_TYPES.allExcept:
                    if (remove) {
                        items = excludeItem(item, selection.items);
                    }
                    else {
                        items = includeItem(item, selection.items);
                    }
                    return {
                        type: items.length <= 0 ? SELECTION_TYPES.all : SELECTION_TYPES.allExcept,
                        items: items,
                        selectedCount: itemCount - items.length,
                    };
                case SELECTION_TYPES.individual:
                default:
                    if (shiftClick) {
                        if (lastSelectionInsert && !_itemInList(item, selection.items)) {
                            items = insertToSelected(item, selection.items, remove);
                        }
                        else if (remove && _itemInList(item, selection.items)) {
                            items = removeFromSelected(item, selection.items);
                        }
                    }
                    else {
                        items = insertToSelected(item, selection.items, remove);
                    }
                    return {
                        type: SELECTION_TYPES.individual,
                        items: items,
                        selectedCount: items.length,
                    };
            }
        };
        var lastSelectionInsert = this.lastSelection.insert;
        // Shift + Click
        if (this.shiftDown && isNotNullOrEmpty(this.lastSelection.id)) {
            var remove = !this.lastSelection.insert &&
                selection &&
                [SELECTION_TYPES.all, SELECTION_TYPES.individual].indexOf(selection.type) >= 0 &&
                _itemIsSelected(selection)(item);
            var firstIndex = isNotNullOrEmpty(data) ? data.findIndex(function (x) { return x[primaryKey] === _this.lastSelection.id; }) : -1;
            var lastIndex = isNotNullOrEmpty(data) ? data.findIndex(function (x) { return x[primaryKey] === item[primaryKey]; }) : -1;
            var startIndex = Math.min(firstIndex, lastIndex);
            var endIndex = Math.max(firstIndex, lastIndex);
            if (remove) {
                if (startIndex === firstIndex) {
                    startIndex += 1;
                }
                else {
                    endIndex -= 1;
                }
            }
            for (var i = startIndex; i <= endIndex; i++) {
                if ((selection === null || selection === void 0 ? void 0 : selection.type) === SELECTION_TYPES.allExcept && remove) {
                    var _items = (items = removeFromSelected(item, selection.items));
                    selection = __assign(__assign({}, selection), { items: _items, selectedCount: itemCount - _items.length });
                }
                else if ((selection === null || selection === void 0 ? void 0 : selection.type) === SELECTION_TYPES.allExcept) {
                    if (!this.lastSelection.insert) {
                        selection = __assign(__assign({}, selection), { items: excludeItem(data[i], selection.items) });
                    }
                    else {
                        selection = __assign(__assign({}, selection), { items: includeItem(data[i], selection.items) });
                    }
                    selection = getSelectionTypeFromAllExcept(selection);
                }
                else {
                    selection = getSelection(data[i], lastSelectionInsert, selection, true, remove);
                }
            }
            this.shiftDown = false;
        }
        else {
            var remove = (selection === null || selection === void 0 ? void 0 : selection.type) === SELECTION_TYPES.allExcept && _itemIsSelected(selection)(item);
            selection = getSelection(item, lastSelectionInsert, selection, false, remove);
        }
        if (isNullOrEmpty(this.lastSelection.id)) {
            this.lastSelection = __assign(__assign({}, this.lastSelection), { id: item[primaryKey] });
        }
        onChangeSelection === null || onChangeSelection === void 0 ? void 0 : onChangeSelection(selection);
    };
    TablePage.prototype.checkHeaderHandler = function (all) {
        var _a, _b, _c, _d;
        if (all) {
            (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 ? void 0 : _b.call(_a, {
                type: SELECTION_TYPES.all,
                items: [],
                selectedCount: this.props.itemCount,
            });
            return;
        }
        (_d = (_c = this.props).onChangeSelection) === null || _d === void 0 ? void 0 : _d.call(_c, {
            type: SELECTION_TYPES.individual,
            items: [],
            selectedCount: 0,
        });
    };
    TablePage.prototype.sortHandler = function (column, sort) {
        var _a;
        var direction = 'default';
        if (((_a = this.props.pageConfig.sorting) === null || _a === void 0 ? void 0 : _a.column) === column) {
            direction = this.props.pageConfig.sorting.direction === 'reverse' ? 'default' : 'reverse';
        }
        var sorting = {
            column: column,
            direction: direction,
            sort: sort,
        };
        var pageConfig = __assign(__assign({}, this.props.pageConfig), { page: 1, sorting: sorting });
        this.props.onChange(pageConfig);
    };
    TablePage.prototype.toggleExpansion = function (id) {
        var _a = this.props, _b = _a.expandedIds, expandedIds = _b === void 0 ? [] : _b, onChangeExpanded = _a.onChangeExpanded;
        if (expandedIds.indexOf(id) >= 0) {
            onChangeExpanded === null || onChangeExpanded === void 0 ? void 0 : onChangeExpanded(expandedIds.filter(function (x) { return x !== id; }));
            return;
        }
        onChangeExpanded === null || onChangeExpanded === void 0 ? void 0 : onChangeExpanded(__spreadArray(__spreadArray([], expandedIds, true), [id], false));
    };
    TablePage.prototype.createRows = function (template) {
        var _this = this;
        var _a = this.props, data = _a.data, disabled = _a.disabled, editId = _a.editId, errorIds = _a.errorIds, warningIds = _a.warningIds, highlight = _a.highlight, primaryKey = _a.primaryKey, selection = _a.selection, showOutliers = _a.showOutliers;
        var _itemIsSelected = itemIsSelected(primaryKey)(selection);
        return data.map(function (x, index) {
            var _a, _b, _c;
            return (React.createElement(Tr, { alt: (_a = template.props) === null || _a === void 0 ? void 0 : _a.alt, automationId: (_c = (_b = template.props) === null || _b === void 0 ? void 0 : _b.automationId) === null || _c === void 0 ? void 0 : _c.call(_b, x, index), disabled: x[primaryKey] !== editId && (Array.isArray(disabled) ? disabled.includes(x[primaryKey]) : disabled), editing: x[primaryKey] === editId, error: errorIds && errorIds.indexOf(x[primaryKey]) >= 0, highlight: highlight && highlight.indexOf(x[primaryKey]) >= 0, key: "generated-row-".concat(x[primaryKey], "-").concat(index), warning: warningIds && warningIds.indexOf(x[primaryKey]) >= 0 }, React.Children.toArray(React.cloneElement(template).props.children).map(function (cell, cIndex) {
                var _a, _b;
                var _props = {
                    children: x,
                    key: "generated-cell-".concat(index, "-").concat(cIndex),
                    outlier: showOutliers && ((_b = (_a = cell === null || cell === void 0 ? void 0 : cell.props) === null || _a === void 0 ? void 0 : _a.outlierAnalyzer) === null || _b === void 0 ? void 0 : _b.call(_a, x)),
                    __editing: x[primaryKey] === editId,
                    __rowIndex: index,
                };
                if (cell.props.__TYPE === 'TdCheckbox') {
                    return React.cloneElement(cell, __assign(__assign({}, _props), { checked: _itemIsSelected(x), onChange: function () { return _this.checkHandler(x); }, outlier: false }));
                }
                return React.cloneElement(cell, _props);
            })));
        });
    };
    TablePage.prototype.createExpandableRows = function (template) {
        var _this = this;
        var _a = this.props, data = _a.data, disabled = _a.disabled, editId = _a.editId, errorIds = _a.errorIds, warningIds = _a.warningIds, expandedIds = _a.expandedIds, primaryKey = _a.primaryKey, renderState = _a.renderState, selection = _a.selection;
        var _itemIsSelected = itemIsSelected(primaryKey)(selection);
        return data.map(function (x) {
            return React.cloneElement(template.props.renderExpandable(x, Array.isArray(disabled) ? disabled.includes(x[primaryKey]) : disabled, x[primaryKey] === editId, renderState), {
                disabled: x[primaryKey] !== editId && (Array.isArray(disabled) ? disabled.includes(x[primaryKey]) : disabled),
                editing: x[primaryKey] === editId,
                error: errorIds && errorIds.indexOf(x[primaryKey]) >= 0,
                warning: warningIds && warningIds.indexOf(x[primaryKey]) >= 0,
                expanded: expandedIds && expandedIds.indexOf(x[primaryKey]) >= 0,
                id: x[primaryKey].toString(),
                key: x[primaryKey],
                onClick: function () { return _this.toggleExpansion(x[primaryKey]); },
                __checked: _itemIsSelected(x),
                __checkHandler: function () { return _this.checkHandler(x); },
            });
        });
    };
    TablePage.prototype.processHead = function (head) {
        var _this = this;
        var _a, _b;
        var checked = ((_a = this.props.selection) === null || _a === void 0 ? void 0 : _a.type) === SELECTION_TYPES.all ||
            ((_b = this.props.selection) === null || _b === void 0 ? void 0 : _b.selectedCount) === this.props.itemCount;
        var children = Array.isArray(head.props.children) ? head.props.children : [head.props.children];
        var sorting = this.props.pageConfig.sorting;
        return React.cloneElement(head, {
            children: children.map(function (x, index) {
                var _a, _b;
                var sortable = isNotNullOrEmpty(sorting);
                var props = {
                    key: "generated-head-cell-".concat(index),
                    onSort: isNotNullOrEmpty(x.props.sort) && sortable
                        ? function () { return _this.sortHandler(x.props.column, x.props.sort); }
                        : undefined,
                    sortArrow: sortable && isNotNullOrEmpty(sorting === null || sorting === void 0 ? void 0 : sorting.direction) && (sorting === null || sorting === void 0 ? void 0 : sorting.column) === x.props.column
                        ? iif((sorting === null || sorting === void 0 ? void 0 : sorting.direction) === 'default', 'asc', 'desc')
                        : '',
                    sortDirection: sortable && (sorting === null || sorting === void 0 ? void 0 : sorting.column) === x.props.column ? sorting === null || sorting === void 0 ? void 0 : sorting.direction : '',
                };
                if (x.props.__TYPE === 'ThCheckbox') {
                    return React.cloneElement(x, __assign(__assign({}, props), { checked: checked, indeterminate: !checked && ((_b = (_a = _this.props.selection) === null || _a === void 0 ? void 0 : _a.selectedCount) !== null && _b !== void 0 ? _b : 0) > 0, onChange: function () { return _this.checkHeaderHandler(!checked); } }));
                }
                return React.cloneElement(x, props);
            }),
        });
    };
    TablePage.prototype.render = function () {
        var _a;
        // const invalidPrimaryKey = isNotNullOrEmpty(this.props.data) && !first(this.props.data as Record<string, unknown>[], {} as Record<string, unknown>).hasOwnProperty(this.props.primaryKey);
        var invalidPrimaryKey = isNotNullOrEmpty(this.props.data) &&
            !(this.props.primaryKey in first(this.props.data, {}));
        var other = removeKeys(this.props, [
            'automationId',
            'children',
            'className',
            'css',
            'data',
            'disabled',
            'editId',
            'errorIds',
            'equalColumnWidths',
            'expandedIds',
            'fixedHeader',
            'fixedLeftColumns',
            'fixedRightColumns',
            'itemCount',
            'loading',
            'lowerPager',
            'onChange',
            'onChangeExpanded',
            'onChangeSelection',
            'pageConfig',
            'primaryKey',
            'renderState',
            'renderToolbar',
            'renderToolbarFooter',
            'renderZeroState',
            'selection',
            'showOutliers',
            'upperPager',
            'warningIds',
            '__TYPE',
        ]);
        var head = getChildByType(this.props.children, ['Thead']);
        var body = getChildByType(this.props.children, ['Tbody']);
        var template = getChildByType(body.props.children, ['RowTemplate']);
        return (React.createElement(React.Fragment, null,
            React.createElement(InvalidPrimaryKey, { visible: invalidPrimaryKey }),
            React.createElement(Core, __assign({}, other, { automationId: this.props.automationId, className: this.props.className, css: this.props.css, disabled: this.props.disabled === true, fixedHeader: this.props.fixedHeader, fixedLeftColumns: this.props.fixedLeftColumns, fixedRightColumns: this.props.fixedRightColumns, itemCount: this.props.itemCount, loading: this.props.loading, lowerPager: this.props.lowerPager, onChangePage: this.onChangePage, page: this.props.pageConfig.page, pageSize: this.props.pageConfig.size, pager: this.props.pager, renderState: this.props.renderState, renderToolbar: this.props.renderToolbar, renderToolbarFooter: this.props.renderToolbarFooter, renderZeroState: this.props.renderZeroState, selectedCount: (_a = this.props.selection) === null || _a === void 0 ? void 0 : _a.selectedCount, upperPager: this.props.upperPager }),
                this.processHead(head),
                React.createElement(Tbody, null, template.props.renderExpandable
                    ? this.createExpandableRows(template)
                    : this.createRows(template)))));
    };
    TablePage.defaultProps = _defaultProps;
    return TablePage;
}(React.Component));
var itemInList = function (primaryKey) {
    return function (item, list) {
        return isNotNullOrEmpty(list) ? list.findIndex(function (x) { return x[primaryKey] === item[primaryKey]; }) >= 0 : false;
    };
};
var itemIsSelected = function (primaryKey) {
    return function (selection) {
        return function (item) {
            if (!selection)
                return false;
            switch (selection.type) {
                case SELECTION_TYPES.allExcept:
                    return !itemInList(primaryKey)(item, selection.items);
                case SELECTION_TYPES.all:
                    return true;
                case SELECTION_TYPES.individual:
                default:
                    return itemInList(primaryKey)(item, selection.items);
            }
        };
    };
};
export default TablePage;
